export default ({ request }) => ({
    ecomAmzRecordInvListApi(data = {}) {
        return request({
            url: '/ecom/amz/record/inv/list',
            method: 'POST',
            data,
        })
    },
    ecomAmzRecordInvErrorListApi(data = {}) {
        return request({
            url: '/ecom/amz/record/inv/error/list',
            method: 'POST',
            data,
        })
    },
    ecomAmzRecordInvErrorDetailApi(data = {}) {
        return request({
            url: '/ecom/amz/record/inv/error/detail',
            method: 'POST',
            data,
        })
    },
    ecomAmzRecordInvErrorSaveApi(data = {}) {
        return request({
            url: '/ecom/amz/record/inv/error/save',
            method: 'POST',
            data,
        })
    },
})
